const removeProtocolFromUrl = (url = '') => {
  if (!url) {
    return '';
  }

  if (url.startsWith('//')) {
    return url.replace(/^\/\//, '');
  }

  return url.replace(/^https?:\/\//, '');
};

export default removeProtocolFromUrl;
